import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentpuneforwedding() {



    const cardData =
    {
        keyword: 'Urbania on Rent Pune for Wedding Functions',
        heading: 'Urbania on rent in pune: Urbania on Rent Pune for Wedding Functions',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania on Rent Pune for Wedding Functions services for families, wedding planners, and event organizers seeking comfortable and spacious transportation. Our well‑maintained Force Urbania fleet provides ample seating, air‑conditioned comfort, and smooth performance, making it ideal for transporting wedding guests, bridal parties, and family members across Pune and nearby locations. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire for wedding functions in Pune.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Urbania on Rent Pune for Wedding Functions",
"description": "Urbania on Rent Pune for Wedding Functions offers spacious and well-maintained Urbania buses for weddings and related events. With comfortable seating, clean interiors, and ample luggage space, these buses ensure a safe and enjoyable travel experience for all guests. Professional and experienced drivers handle local and long-distance routes with care, making sure everyone arrives on time. The service caters to families, large groups, and VIP wedding guests, providing both AC and non-AC options and a stress-free transportation solution for any wedding function."
},
{
"name": "Wedding Urbania Bus Hire Pune",
"description": "Wedding Urbania Bus Hire Pune provides tailored bus rental solutions for wedding celebrations, accommodating guests traveling to multiple venues. The buses are equipped for comfort with cushioned seats, air-conditioning, and spacious interiors, ensuring a pleasant journey. Experienced chauffeurs navigate traffic and routes efficiently, maintaining punctuality throughout the event. This service is ideal for families, corporate attendees, and large groups seeking reliable, safe, and coordinated wedding transportation in Pune and surrounding areas."
},
{
"name": "Urbania for Marriage Events Pune",
"description": "Urbania for Marriage Events Pune specializes in providing organized and comfortable bus services for all types of marriage ceremonies. From pre-wedding functions to main ceremonies and receptions, these buses offer reliable travel with well-trained drivers. The vehicles are spacious, clean, and safe, featuring both AC and non-AC options. Large families and groups can travel together seamlessly, while event coordinators can depend on timely pickups and drop-offs to ensure smooth event logistics."
},
{
"name": "Urbania Guest Transport Pune",
"description": "Urbania Guest Transport Pune ensures seamless and convenient travel for all wedding guests, whether attending a local ceremony or traveling from neighboring cities. The service provides ample seating, safety features, and comfortable interiors to make long and short journeys enjoyable. Professional drivers ensure punctual arrivals and departures, and the buses are maintained to the highest safety standards. Families, VIPs, and large groups can rely on this service for coordinated, stress-free guest transportation."
},
{
"name": "Urbania AC Wedding Bus Pune",
"description": "Urbania AC Wedding Bus Pune provides fully air-conditioned buses to keep guests comfortable during wedding journeys, even in warm weather. With plush seating, clean interiors, and sufficient luggage space, these buses ensure a relaxed and enjoyable ride. Experienced chauffeurs handle the routes efficiently, maintaining punctuality for multiple event stops. The service is perfect for families, corporate groups, and VIP guests who prioritize comfort and convenience during wedding celebrations."
},
{
"name": "Luxury Wedding Urbania Pune",
"description": "Luxury Wedding Urbania Pune offers premium buses with elegant interiors, plush seating, and superior ride comfort for VIP wedding guests and special events. Each bus is meticulously maintained and provides both AC and non-AC options, making long and short journeys luxurious and hassle-free. Professional drivers ensure safe and punctual travel, while ample luggage space accommodates gifts and personal belongings. This service is ideal for high-profile weddings, family celebrations, and corporate wedding events."
},
{
"name": "Affordable Wedding Urbania Hire Pune",
"description": "Affordable Wedding Urbania Hire Pune provides budget-friendly bus rental options for weddings without compromising on safety or comfort. These buses are ideal for families and groups looking to transport guests efficiently and reliably. The vehicles are spacious, clean, and well-maintained, offering AC and non-AC choices. Experienced drivers ensure timely pickups and drop-offs, making this service a practical and cost-effective solution for wedding transportation in Pune and nearby areas."
},
{
"name": "Chauffeur Driven Wedding Urbania Pune",
"description": "Chauffeur Driven Wedding Urbania Pune offers a stress-free travel experience with trained, verified drivers familiar with local and long-distance wedding routes. The service ensures that all guests arrive safely and punctually at their destinations. Comfortable, spacious buses with clean interiors and ample luggage space make the journey enjoyable. This service is ideal for VIP guests, family members, and corporate attendees attending wedding functions and related events."
},
{
"name": "Urbania for Baraat Pune",
"description": "Urbania for Baraat Pune provides specialized buses for transporting the wedding procession with style and comfort. Equipped with spacious seating, safety features, and clean interiors, these buses ensure a lively yet safe journey for all participants. Professional drivers manage the routes efficiently, maintaining punctuality for all wedding-related events. The service accommodates large groups and families, making it a reliable option for an organized and enjoyable Baraat experience."
},
{
"name": "Urbania for Family Wedding Travel Pune",
"description": "Urbania for Family Wedding Travel Pune offers comfortable and safe buses for family members attending wedding events. The service focuses on spacious seating, clean interiors, and professional drivers to ensure a pleasant travel experience. Both AC and non-AC options are available, and ample luggage space is provided for gifts and personal belongings. Families can enjoy coordinated travel without the stress of multiple vehicles, ensuring everyone reaches the venue on time."
},
{
"name": "Corporate Wedding Transport Urbania Pune",
"description": "Corporate Wedding Transport Urbania Pune provides organized and professional bus services for corporate guests attending weddings. With comfortable seating, clean interiors, and reliable drivers, this service ensures punctual arrivals and smooth travel between venues. AC and non-AC buses are available, making it suitable for large corporate groups, VIPs, and clients who require efficient and stress-free transportation during wedding celebrations."
},
{
"name": "Best Wedding Urbania Rental Pune",
"description": "Best Wedding Urbania Rental Pune is a premium bus rental service known for its reliable vehicles, professional drivers, and exceptional customer service. The buses are spacious, clean, and equipped with modern amenities, offering both AC and non-AC options. Families, corporate guests, and large groups can enjoy safe, punctual, and comfortable transportation for all wedding events, making this service the preferred choice for weddings in Pune."
},
{
"name": "Urbania Group Wedding Travel Pune",
"description": "Urbania Group Wedding Travel Pune caters to large groups attending weddings, providing spacious and well-maintained buses for safe and coordinated travel. The service includes professional drivers, ample luggage space, and comfortable seating, ensuring that everyone travels together conveniently. Both AC and non-AC buses are available, making it ideal for family gatherings, corporate groups, and large wedding parties."
},
{
"name": "Reliable Wedding Urbania Service Pune",
"description": "Reliable Wedding Urbania Service Pune ensures dependable and punctual transportation for all wedding guests. The buses are clean, safe, and equipped for comfortable travel. Professional drivers handle the routes efficiently, guaranteeing timely arrivals and departures for multiple event locations. This service is suitable for families, VIP guests, corporate attendees, and large groups seeking trustworthy and well-managed wedding transport solutions."
},
{
"name": "Wedding Event Transport Urbania Pune",
"description": "Wedding Event Transport Urbania Pune provides comprehensive bus services for all types of wedding-related events. The service ensures comfortable, safe, and coordinated transportation for guests, family members, and corporate attendees. With experienced drivers, spacious seating, clean interiors, and both AC and non-AC options, the service handles one-way, round-trip, and multi-stop wedding travel efficiently, making every journey stress-free and enjoyable."
}
],
"tableData": [
["Urbania on Rent Pune for Wedding Functions", "Wedding Urbania Bus Hire Pune"],
["Urbania for Marriage Events Pune", "Urbania Guest Transport Pune"],
["Urbania AC Wedding Bus Pune", "Luxury Wedding Urbania Pune"],
["Affordable Wedding Urbania Hire Pune", "Chauffeur Driven Wedding Urbania Pune"],
["Urbania for Baraat Pune", "Urbania for Family Wedding Travel Pune"],
["Corporate Wedding Transport Urbania Pune", "Best Wedding Urbania Rental Pune"],
["Urbania Group Wedding Travel Pune", "Reliable Wedding Urbania Service Pune"],
["Wedding Event Transport Urbania Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania on Rent Pune for Wedding Functions for Comfortable Guest Travel",
        "WhyChoosedescription": "Urbania on Rent Pune for Wedding Functions is perfect for transporting your wedding guests, family, and friends comfortably to and from ceremonies, ensuring a smooth and memorable experience."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses in Pune are equipped with air-conditioning, reclining seats, ample legroom, and plenty of luggage space for all guests and wedding essentials."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are licensed, trained, and well-versed with Pune city routes and wedding venues to ensure safe, punctual, and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania on Rent Pune for Wedding Functions offers competitive rates with no hidden charges, making group travel for weddings cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We offer round-the-clock booking assistance and dedicated customer support for wedding travel planning and last-minute arrangements."
    },
    {
        "WhyChooseheading": "Flexible Wedding Travel Packages",
        "WhyChoosedescription": "Choose from single-venue transport, multi-location wedding events, pickup/drop customization, and tailored itineraries as per your schedule."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and maintained to provide a hygienic, comfortable travel experience for your guests."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania on Rent Pune for Wedding Functions guarantees on-time pickups, dependable service, and a smooth travel experience for wedding guests."
    }
]
}
const faqData = [
    {
        question: 'Can Urbania on Rent Pune for Wedding Functions accommodate large groups?',
        answer: 'Yes, it is ideal for transporting large numbers of wedding guests, family members, and friends comfortably.'
    },
    {
        question: 'How can I book Urbania on Rent Pune for Wedding Functions?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Urbania on Rent Pune for Wedding Functions?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are the drivers experienced with wedding event travel?',
        answer: 'Yes, all drivers are trained and familiar with Pune city routes and popular wedding venues.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off points are available across Pune and surrounding areas.'
    },
    {
        question: 'Is Urbania on Rent Pune for Wedding Functions available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during wedding travel?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and large wedding groups?',
        answer: 'Yes, Urbania on Rent Pune for Wedding Functions is ideal for families, friends, and large wedding gatherings.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Jadhav',
        feedback: 'We booked an Urbania bus for our wedding guests in Pune. The service was punctual, the bus was comfortable, and guests had a great experience.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Ananya Deshpande',
        feedback: 'Excellent service and professional driver. Urbania on Rent Pune for Wedding Functions made our transport arrangements effortless and stress-free.',
        rating: 5
    }
];















































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent Pune for Wedding Functions",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-wedding-pune.jpg",
  "description": "Urbania on Rent Pune for Wedding Functions offers AC and luxury Urbania buses for wedding guest transport, corporate wedding trips, family travel, and group events. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation for marriage events and wedding functions in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-pune-for-wedding-functions"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania on Rent Pune for Wedding Functions | AC & Luxury Wedding Buses 
  </title>

  <meta
    name="description"
    content="Book Urbania on Rent Pune for Wedding Functions for guest transport, corporate wedding trips, family travel, and group events. AC and luxury chauffeur-driven Urbania buses provide safe, comfortable, and convenient transportation for marriage events and wedding functions in Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent Pune for Wedding Functions, Wedding Urbania Bus Hire Pune, Urbania for Marriage Events Pune, Urbania Guest Transport Pune, Urbania AC Wedding Bus Pune, Luxury Wedding Urbania Pune, Affordable Wedding Urbania Hire Pune, Chauffeur Driven Wedding Urbania Pune, Urbania for Baraat Pune, Urbania for Family Wedding Travel Pune, Corporate Wedding Transport Urbania Pune, Best Wedding Urbania Rental Pune, Urbania Group Wedding Travel Pune, Reliable Wedding Urbania Service Pune, Wedding Event Transport Urbania Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/110.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentpuneforwedding;